import Axios from 'axios'

// 根目录
export const rootFile = '/pmi/'
// 接口域名
export const apiDomain = getApiDomain()
// 接口返回状态码
export const resCode = {
  ERR_OK: 1000,
  ERR_EX: 1005,
  ERR_OR: 1006,
  ERR_XS: 2000,
  ERR_RF: 1004,
  ERR_NR: 1007,
  ERR_NL: 1008,
  ERR_DS: 1009,
  ERR_RT: 1015,
  ERR_SK: 21002
}
// 新干线观察下载地址
export const androidAPKUrl = 'http://xbgtoa.96369.net:8080/xiben.apk'
export const iosAPKUrl =
  'https://itunes.apple.com/cn/app/%E9%87%87%E8%B4%AD%E7%BB%8F%E7%90%86%E4%BA%BA/id1439408744?mt=8'
// 加西亚下载地址
export const androidJXYAPKUrl = 'http://xbgtoa.xb969.com:8080/xboa.apk'
export const iosJXYAPKUrl =
  'https://itunes.apple.com/cn/app/%E8%A5%BF%E6%9C%AC%E5%8A%A0%E8%A5%BF%E4%BA%9A/id1331763540?mt=8'
// 返回值
export function upSwitch (res) {
  return res.data
}
// 显示条数
export const pageSize = 10

/**
 *loading配置
 */
let loading = {
  load: null,
  showLoading: true,
  loadingMsg: '加载中...'
}

/**
 * 设置默认数据
 */
Axios.defaults.data = function (data) {
  return data
}

/**
 * 发送到服务器前修改请求数据
 */
Axios.defaults.transformRequest = function (data) {
  if (data) {
    data = JSON.stringify(data)
  }
  return data
}

/**
 * getService get请求
 * @param {*} url
 * @param {*} param
 * @param {*} showLoading
 */
export const getService = (url = '', param = {}, showLoading = true) => {
  loading.showLoading = showLoading
  return new Promise((resolve, reject) => {
    Axios.get(
      url,
      { param: param },
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
      .then(res => {
        const { data } = res
        resolve(data)
      })
      .catch(err => {
        errorMsg(err)
        reject(err)
      })
  })
}

/**
 * postService post请求
 * ps：需要注意qs.stringify
 * @param {*} url
 * @param {*} param
 * @param {*} showLoading
 */
export const postService = (url = '', param = {}, showLoading = true) => {
  loading.showLoading = showLoading
  return new Promise((resolve, reject) => {
    Axios.post(url, param, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    })
      .then(res => {
        const { data } = res
        resolve(data)
      })
      .catch(err => {
        errorMsg(err)
        reject(err)
      })
  })
}

/**
 * postJsonService post请求
 * @param {*} url
 * @param {*} param
 * @param {*} showLoading
 */
export const postJsonService = (url = '', param = {}, showLoading = true) => {
  loading.showLoading = showLoading
  return new Promise((resolve, reject) => {
    Axios.post(url, param, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
      .then(res => {
        const { data } = res
        resolve(data)
      })
      .catch(err => {
        errorMsg(err)
        reject(err)
      })
  })
}

/**
 * postFormData
 * formData示例（如果是文件数组，则key一样即可）
 * let formData = new FormData()
 * formData.append("username", '张三')
 * formData.append("file", file)
 * formData.append("file", file)
 * @param {*} url
 * @param {*} formData
 * @param {*} showLoading
 */
export const postFormDataService = (
  url = '',
  formData = {},
  showLoading = true
) => {
  loading.showLoading = showLoading
  return new Promise((resolve, reject) => {
    Axios.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data;' }
    })
      .then(res => {
        const { data } = res
        resolve(data)
      })
      .catch(err => {
        errorMsg(err)
        reject(err)
      })
  })
}

/**
 * 异常错误提示
 * @param {*} err
 */
function errorMsg (err) {
  console.error(err)
}

/**
 * 获取api域名
 * @param {*} url 请求地址
 */
export function getApiDomain (url = 'pmi', from) {
  let apiUrl = ''
  console.log('url', url)

  if (url.indexOf('pmi') >= 0 || (from != null && from.indexOf('pmi') >= 0)) {
    apiUrl = 'https://pmi.xb969.com/'
    if (location.host.indexOf('xgx.xb969.com') >= 0) {
      apiUrl = 'https://xgx.xb969.com/'
    } else if (location.host.indexOf('localhost') >= 0) {
      apiUrl = 'http://localhost:8083/'
    // } else if (location.host.indexOf('192.168.17.209:8081') >= 0) {
    } else if (location.host.indexOf('106.15.187.217') >= 0) {
      apiUrl = 'http://106.15.187.217:8082/'
    }
  } else if (
    url.indexOf('fund') >= 0 ||
    (from != null && from.indexOf('fund') >= 0)
  ) {
    apiUrl = 'https://pmi.xb969.com/'
    if (location.host.indexOf('xgx.xb969.com') >= 0) {
      apiUrl = 'https://xgx.xb969.com/'
    } else if (location.host.indexOf('localhost') >= 0) {
      apiUrl = 'http://localhost:8099/'
    } else if (location.host.indexOf('106.15.187.217') >= 0) {
      apiUrl = 'http://106.15.187.217:8082/'
    }
  } else if (url.indexOf('pmrest') != -1) {
    console.log('112324yearAssessmentNightingaleChart')
    // apiUrl = 'http://106.15.187.217:8080/pmrest'
    apiUrl = 'https://pm.xb969.com/'
    if (location.host.indexOf('xgx.xb969.com') >= 0) {
      apiUrl = 'https://xgx.xb969.com/'
    } else if (location.host.indexOf('localhost') >= 0) {
      apiUrl = 'http://localhost:8083/'
    } else if (location.host.indexOf('106.15.187.217') >= 0) {
      apiUrl = 'http://106.15.187.217:8080/'
    }

    return apiUrl
  }

  if (location.host.indexOf('localhost') >= 0) {
    apiUrl = 'http://localhost:8083/'
  // } else if (location.host.indexOf('192.168.17.209:8081') >= 0) {
  }
  return apiUrl
}



// WEBPACK FOOTER //
// ./src/api/config.js